export default __webpack_public_path__ + "static/media/pmk-logo.a35b589e.svg";